import React from "react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import {
  Form,
  Input,
  Typography,
  Row,
  Col,
  Button,
  Rate,
  Modal,
  Avatar,
  Radio,
} from "antd";
import {
  required,
  whiteSpace,
  maxLengthC,
} from "../../config/FormValidation";
import { langs } from "../../config/localization";
import {
  addBookingReviewAction,
  addReveiw,
  editBookingReviewAction,
} from "../../store/actions";
import { MESSAGES } from "../../config/Message";
import { STATUS_CODES } from "../../config/StatusCode";
import { capitalizeFirstLetter } from "../../components/common";
import moment from "moment";
import { BASE_URL } from "../../api";
import { replaceImageURL } from "../../common/Navigation";
const { Paragraph } = Typography;
const { TextArea } = Input;

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
  labelAlign: "left",
  colon: false,
};
const tailLayout = {
  wrapperCol: { span: 24 },
  className: "align-center pt-20",
};

class LeaveReviewModel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
    };
  }

  /**
   * @method handleRatingChange
   * @description handle rating selection
   */
  handleRatingChange = (e) => {
    this.setState({
      value: e.target.value,
    });
  };

  /**
   * @method onFinish
   * @description handle on submit
   */
  onFinish = (values) => {
    const { classifiedDetail, selectedReview, rating_type, bookingDetail } = this.props;
    if (selectedReview) {
      const requestData = {
        review_id: selectedReview.id,
        business_id: bookingDetail?.id,
        rating_type: selectedReview.rating_type,
        module: this.props.module,
        title: values.title,
        rating: values.rating,
        review: values.review,
      };

      this.props.editBookingReviewAction(requestData, (res) => {
        if (res.success) {
          this.props.callNext();
          toastr.success(langs.success, MESSAGES.REVIEW_UPDATE_SUCCESS);
          this.props.onCancel();
        }
      });

    } else {
      const requestData = {
        business_id: bookingDetail?.id,
        classified_id: classifiedDetail?.id,
        rating_type: rating_type,
        module: this.props.module,
        title: values.title,
        rating: values.rating,
        review: values.review,
      };
      this.props.addBookingReviewAction(requestData, (res) => {
        if (res.success) {
          this.props.callNext();
          toastr.success(langs.success, MESSAGES.REVIEW_ADD_SUCCESS);
          this.props.onCancel();
        }
      });
    }
  };

  /**
   * @method getInitialValue
   * @description get initial values
   */
  getInitialValue = () => {
    let data = this.props.selectedReview;
    if (data) {
      let temp = {
        title: data.title,
        review: data.review,
        rating: data.rating,
      };
      return temp;
    }
  };

  /**
   * @method render
   * @description render component
   */
  render() {
    const { visible, selectedReview, bookingDetail, userDetails } = this.props;


    const { value } = this.state;
    return (
      <Modal
        title={bookingDetail ? "Business review" : "Product Review"}
        visible={visible}
        className={"dashboardReviewModal"}
        width={752}
        footer={false}
        onCancel={this.props.onCancel}
      >
        <div className="reviewModalBody">
          <Row className="">
            <Col md={24}>
              <div className="reviews-content-left">
                <div className="reviews-content-avatar">
                  <Avatar
                    src={replaceImageURL(userDetails?.image, 53, 53)}
                    size={53}
                    className=''
                  />

                </div>
                <div className="productname">
                  <h2>{selectedReview?.product_name} </h2>
                  <div className="reviews-content-avatar-detail">
                    Posted By:{capitalizeFirstLetter(userDetails?.name)}
                    <p>
                      <Paragraph>
                        {userDetails?.created_at &&
                          `Member Since ${moment(userDetails.created_at).format("MMMM YYYY")}`}
                      </Paragraph>
                    </p>
                  </div>
                </div>

              </div>
            </Col>
          </Row>
          <Form
            {...layout}
            name="basic"
            onFinish={this.onFinish}
            initialValues={this.getInitialValue()}
          >
            <Form.Item
              label={"Title"}
              name="title"
              rules={[required(""), whiteSpace("Review")]}
              className="custom-astrix"
            >
              <Input rows={5} placeholder={"..."} className="shadow-input" />
            </Form.Item>
            <Form.Item
              // label='Body of message (1500) characters remaining'
              label={"Comment"}
              name="review"
              rules={[required(""), whiteSpace("Review"), maxLengthC(300)]}
              className="custom-astrix"
            >
              <TextArea
                rows={4}
                placeholder={"Write comments here..."}
                className="shadow-input"
              />
            </Form.Item>
            <Form.Item
              label="Select your rating"
              name="rating"
              rules={[required("")]}
              className="ratingSec"
            >
              <Radio.Group onChange={this.handleRatingChange} value={value}>
                <Radio value={5}>
                  <Rate disabled defaultValue={5} />{" "}
                  <span className="rating-dgt-txt">5 Excelent</span>
                </Radio>
                <Radio value={4}>
                  <Rate disabled defaultValue={4} />{" "}
                  <span className="rating-dgt-txt">4 Very Good</span>
                </Radio>
                <Radio value={3}>
                  <Rate disabled defaultValue={3} />{" "}
                  <span className="rating-dgt-txt">3 Average</span>
                </Radio>
                <Radio value={2}>
                  <Rate disabled defaultValue={2} />{" "}
                  <span className="rating-dgt-txt">2 Very Poor</span>
                </Radio>
                <Radio value={1}>
                  <Rate disabled defaultValue={1} />{" "}
                  <span className="rating-dgt-txt">1 Terrible</span>
                </Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item {...tailLayout} className="submitRow">
              <Button type="default" htmlType="submit">
                {selectedReview ? "Update" : "Send"}
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Modal>
    );
  }
}

//  Connect with redux through connect methode
const mapStateToProps = (store) => {
  const { profile: { userProfile, businessProfile } } = store;
  return { userDetails: userProfile ?? businessProfile };
};

export default connect(mapStateToProps, {
  addReveiw,
  addBookingReviewAction,
  editBookingReviewAction,
})(LeaveReviewModel);
